import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { NavLink, useLocation } from 'react-router-dom';
import UserMenuOptions from '../UserMenuOptions/UserMenuOptions';
import '../Navbar/navbar.scss';
import './navbarauth.scss';
import { IoMdMenu } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebar } from '../../actions';
import { Loader, RingProgress } from '@mantine/core';
import useTargets from '../../hooks/useTargets';
import { Box } from '@mui/material';

function NavbarAuth() {
  const dispatch = useDispatch();
  const { first_name, last_name, email } = useSelector((state) => state.auth);
  const { pathname } = useLocation();

  //if senior marketer
  const [sideOpen, setSideOpen] = useState(false);

  useLayoutEffect(() => {
    const navbar = document.getElementsByClassName('navbar')[0];
    document.documentElement.style.setProperty('--navheight', navbar.clientHeight + 'px');
  }, []);

  const { isLoading, selectedYear, selectedMonth } = useTargets(null, null, sideOpen);

  const colors = {
    'bpo-farm': '#2d8cff',
    'premier-agent-website': '#fbbc05',
    'deal-analyzer': '#eb3f5e',
    'combo-package': '#00c853',
  };

  return (
    <>
      <SideModal open={sideOpen} onClose={() => setSideOpen(false)}>
        <div className="sideModal__main">
          {isLoading ? (
            <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
              <Loader size="xl" />
            </Box>
          ) : (
            <>
              <div className="sideModal_graph">
                <RingProgress
                  sections={
                    selectedYear?.sub_targets?.map((sub) => ({
                      value: (sub?.amount / selectedYear.amount) * 100,
                      color: colors[sub?.package_name],
                      tooltip: sub?.package_name?.split('-').join(' '),
                    })) || []
                  }
                />

                <div>
                  <p>BPO Farm </p>
                  <p>Premier Agent </p>
                  <p>Deal Analyzer </p>
                  <p>Combo Package</p>
                </div>
              </div>
              {!!selectedYear && (
                <Summary
                  title="Yearly Target"
                  bpo={selectedYear?.sub_targets.find((item) => item.package_name === 'bpo-farm')?.amount_per_team || 0}
                  pwa={
                    selectedYear?.sub_targets.find((item) => item.package_name === 'premier-agent-website')
                      ?.amount_per_team || 0
                  }
                  dealanalzer={
                    selectedYear?.sub_targets.find((item) => item.package_name === 'deal-analyzer')?.amount_per_team ||
                    0
                  }
                  combo={
                    selectedYear?.sub_targets.find((item) => item.package_name === 'combo-package')?.amount_per_team ||
                    0
                  }
                />
              )}
              {!!selectedMonth && (
                <Summary
                  title="Monthly Target"
                  bpo={
                    selectedMonth?.sub_targets.find((item) => item.package_name === 'bpo-farm')?.amount_per_team || 0
                  }
                  pwa={
                    selectedMonth?.sub_targets.find((item) => item.package_name === 'premier-agent-website')
                      ?.amount_per_team || 0
                  }
                  dealanalzer={
                    selectedMonth?.sub_targets.find((item) => item.package_name === 'deal-analyzer')?.amount_per_team ||
                    0
                  }
                  combo={
                    selectedMonth?.sub_targets.find((item) => item.package_name === 'combo-package')?.amount_per_team ||
                    0
                  }
                />
              )}
            </>
          )}
        </div>
      </SideModal>
      <div className="navbar-mod navbar">
        <IoMdMenu
          style={{
            position: 'absolute',
            zIndex: '10000',
            width: '30px',
            height: '30px',
            cursor: 'pointer',
          }}
          color="white"
          onClick={() => {
            dispatch(toggleSidebar());
          }}
        />

        <NavLink to="/" className="logo logo-mod">
          BPO HOMES
        </NavLink>
        <ul className="list logged" style={{ marginRight: '50px' }}>
          {pathname === '/dashboard' && (
            <p className="nvb_target" onClick={() => setSideOpen(true)}>
              Sales Target
            </p>
          )}
          {/* <HelpIcon />
          <SettingsIcon /> */}
          {/* Depends on the state of the user⬇️ */}
          {/* <NavLink to='/feed'>Feed</NavLink> */}
          {/* <HeartIcon /> */}
          {/* TODO name should be user's name */}
          <UserMenuOptions name={`${first_name} ${last_name}`} email={email} />
        </ul>
      </div>
    </>
  );
}

export default NavbarAuth;

const SideModal = ({ children, open, onClose, style }) => {
  if (!open) return null;
  return createPortal(
    <>
      <div className="sideModal_overlay" onClick={onClose} />
      <div className="sideModal_content" style={style}>
        {children}
      </div>
    </>,
    document.getElementById('portal')
  );
};

const Summary = ({ title, bpo, pwa, dealanalzer, combo }) => {
  return (
    <div className="sideModal_div">
      <div>
        <p>
          {' '}
          ${' '}
          {Number(bpo + pwa + dealanalzer + combo)
            .toFixed(0)
            .toLocaleString('en-US', { minimumFractionDigits: 0 })}
        </p>
        <span>{title}</span>
      </div>
      <div>
        <div>
          <p>$ {Number(bpo).toFixed(0).toLocaleString('en-US', { minimumFractionDigits: 0 })}</p>
          <span>BPO Farm Agent</span>
        </div>
        <div>
          <p>$ {Number(pwa).toFixed(0).toLocaleString('en-US', { minimumFractionDigits: 0 })}</p>
          <span>Premier Website Agent</span>
        </div>
        <div>
          <p>$ {Number(dealanalzer).toFixed(0).toLocaleString('en-US', { minimumFractionDigits: 0 })}</p>
          <span>Deal Analyzer</span>
        </div>
        <div>
          <p>$ {Number(combo).toFixed(0).toLocaleString('en-US', { minimumFractionDigits: 0 })}</p>
          <span>Combo Package</span>
        </div>
      </div>
    </div>
  );
};
